/* eslint-disable no-unreachable */
/* eslint-disable import/no-anonymous-default-export */
/**
 * Función que formatea una fecha proporcionada en diferentes formatos.
 * La fecha puede ser representada como un objeto con los campos `_seconds` o `seconds`,
 * que indican la cantidad de segundos desde la época UNIX.
 * Dependiendo de los parámetros proporcionados, la función puede devolver una fecha
 * en diferentes formatos, con o sin la hora, o con un rango de horas.
 * @param {Object} fechaObj - El objeto que contiene la fecha en formato de segundos.
 * @param {boolean} complete - Indica si la fecha debe incluir el día de la semana y la hora completa.
 * @param {boolean} includemaxHours - Indica si se debe mostrar un rango de horas (hora y hora máxima).
 * @returns {string} La fecha formateada como una cadena, o "Sin fecha" si no se proporciona un valor de fecha.
 * @example
 * // Devuelve: "Lunes 01/01/2024 a las 14:30"
 * formatDate({ _seconds: 1672573200 }, true, false);
 * @example
 * // Devuelve: "Lunes 01/01/2024 entre 14:30 - 15:30"
 * formatDate({ _seconds: 1672573200 }, false, true);
 * @example
 * // Devuelve: "01/01/2024"
 * formatDate({ _seconds: 1672573200 }, false, false);
 */
export default (fechaObj, complete, includemaxHours) => {
    // Convertir los segundos a milisegundos y crear un objeto de fecha
    if (!fechaObj) return "Sin fecha";
    const fecha = new Date(fechaObj._seconds ? fechaObj._seconds * 1000 : fechaObj.seconds * 1000);
    const weekDay = fecha.getDay();
    // Obtener los componentes de la fecha
    const dia = fecha.getDate();
    const mes = fecha.getMonth() + 1; // Los meses son indexados desde 0
    const año = fecha.getFullYear();
    const hours = fecha.getHours();
    const maxHours = fecha.getHours() + 1; // Add hour
    const minutes = fecha.getMinutes();
    let newDate;
    // Formatear la fecha en el formato deseado (DD/MM/YYYY)
    if (complete) {
      newDate = `${days[weekDay]} ${dia < 10 ? "0" + dia : dia}/${
        mes < 10 ? "0" + mes : mes
      }/${año} a las ${hours < 10 ? "0" + hours : hours}:${
        minutes < 10 ? "0" + minutes : minutes
      }`;
    }
    else if (includemaxHours) {
      newDate = `${days[weekDay]} ${dia < 10 ? "0" + dia : dia}/${
        mes < 10 ? "0" + mes : mes
      }/${año} entre ${hours < 10 ? "0" + hours : hours}:${
        minutes < 10 ? "0" + minutes : minutes
      } - ${maxHours < 10 ? "0" + maxHours : maxHours}:${
        minutes < 10 ? "0" + minutes : minutes
      }`;
    } else {
      newDate = ` ${dia < 10 ? "0" + dia : dia}/${
        mes < 10 ? "0" + mes : mes
      }/${año}`;
    }
    return newDate;
  };
  
  /**
   * Array que contiene los días de la semana en español.
   * 
   * @type {Array<string>}
   */
  const days = [
    "Domingo",
    "Lunes",
    "Martes",
    "Miércoles",
    "Jueves",
    "Viernes",
    "Sábado",
  ];
  